<template>
  <a-modal
    width="70%"
    :title="$t('device.changeRemark')"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="cancel"
    destroyOnClose>
    <div class="main">
      <div class="left">
        <div class="old" v-if="record.remark">
          {{text + ': ' + record.remark}}
        </div>
        <label class="text">{{newText}}:</label>
        <a-input class="sel" v-model="remark" ></a-input>
      </div>
    </div>
  </a-modal>
</template>
<script>
import {httpModel} from '../../http/httpModel'
export default {
  props: {
    record: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      visable: false,
      remark: '',
      text: '',
      newText: '',
    }
  },
  methods: {
    // ok
    handleOk () {
      if (this.remark) {
        let param = {
          id: this.record.id,
          deviceExtension: {
            remark: this.remark
          }
        }
        httpModel.setDeviceRemark(param).then((res) => {
          // console.log(res)
          this.visable = false
          this.$emit('Ok')
          this.$notification.success({
            message: this.$t('global.commitSuccess')
          })
        })
      } else {
        this.$notification.error({
          message: this.$t('global.isRequired')
        })
      }
    },
    // cancel
    cancel () {
      this.visable = false
      this.$emit('quit')
    },
    getDeviceModel () {
      httpModel.getDeviceModelById(this.record.id).then((res) => {
        // console.log(res)
        if (res.capbilityLockDetect === true && res.capbilityElock === false) {
          this.text = this.$t('device.securitySeal')
          this.newText = this.$t('device.newSecuritySeal')
        } else {
          this.text = this.$t('device.remark')
          this.newText = this.$t('device.newRemark')
        }
        this.visable = true
      })
    }
  },
  created () {
    this.getDeviceModel()
  }
}
</script>
<style lang="less" scoped>
.old {
  margin-bottom: 20px; 
}
.text {
  margin-right: 10px;
}
.sel {
  width: 300px;
}
</style>